import React from 'react';
import SeoHead from '../components/SeoHead';
import { PAGE_SEO } from '../constants/seo';
import './Page.css';

const ForBusiness = () => {

  const benefits = [
    {
      title: 'Increase Retention',
      description: 'Retaining members has consistently been a paramount concern for fitness centres. Our tailored solutions are designed to effectively address this challenge, providing you with the tools and strategies to significantly improve members retention. Elevate your members stability and engagement with our proven solutions.',
      image: '/images/blog/deb746_6bac9e003136489da94c316701c290f6~mv2.png',
      icon: '',
      imagePosition: 'right'
    },
    {
      title: 'Increase Productivity',
      description: 'Research indicates that a single healthy employee can contribute as much as three regular employees. Cultivate a healthier workforce within your fitness centre to significantly amplify productivity and expedite the achievement of your goals.',
      image: '/images/blog/deb746_4c449870d96546ac81245c68268fc813~mv2.png',
      icon: '',
      imagePosition: 'left'
    },
    {
      title: 'Increase Profitability',
      description: 'Maximize business efficiency and boost profits by empowering your members with enhanced productivity. Elevate your members engagement and retention rates by providing comprehensive healthcare benefits. Invest in your members well-being to ensure a healthier and more committed, leading to increased profitability and reduced attrition.',
      image: '/images/blog/deb746_9749805609534fc2a5cbd319c2d9c9c0~mv2.png',
      icon: '',
      imagePosition: 'right'
    },
    {
      title: 'Get Weightage in Hiring',
      description: 'Securing top-tier talent goes beyond competitive compensation packages. Today, prospective employees seek additional benefits that prioritize their well-being in the workplace. Our innovative solutions offer a distinct advantage in attracting and retaining top talent by providing comprehensive well-being support. Elevate your hiring strategy with offerings that resonate beyond traditional packages.',
      image: '/images/blog/deb746_b6af73c8c9504da98558be20376c4362~mv2.png',
      icon: '',
      imagePosition: 'left'
    },
    {
      title: 'Win the Trust',
      description: 'Trust is cultivated through genuine care. Extend a caring hand to your members by helping them achieve fitness & health goals with savings. Strengthen their trust with your centre.',
      image: '/images/blog/deb746_9d1270a915794691bd2a5f298aec264d~mv2.png',
      icon: '',
      imagePosition: 'right'
    },
    {
      title: 'Affordable',
      description: 'While offering healthcare benefits is crucial, we understand the cost concerns many organizations face. Our tailored solutions are designed to make healthcare benefits accessible and affordable. With our customized plans, you can provide comprehensive healthcare benefits to your members at a reasonable cost, ensuring their well-being without compromising your budget.',
      image: '/images/blog/deb746_e9ca608701224614bdbf227303747ceb~mv2.png',
      icon: '',
      imagePosition: 'left'
    },
    {
      title: 'Long Term Success',
      description: 'Success is a journey that spans years, requiring dedicated individuals willing to put in the effort. Loyal members are the backbone of any fitness centre, contributing significantly to the long-term game. Our solutions go beyond just aiding in hiring and retention; they are designed to be strategic partners in your organization\'s enduring success. Invest in the future with solutions that foster loyalty and dedication among your members.',
      image: '/images/blog/deb746_47f7a467312d4195b53573f99727430e~mv2.png',
      icon: '',
      imagePosition: 'right'
    }
  ];

  return (
    <div className="page">
      <SeoHead {...PAGE_SEO.forBusiness} />
      <section className="page-header blog-header" style={{ backgroundImage: 'url(/images/blog/deb746_b659eca4640e470d99ec52bab788346c~mv2.jpg)' }}>
        <div className="container">
          <h1>For Business</h1>
          <p className="page-subtitle">Making quality healthcare affordable for MSME</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          {/* Main Content Section */}
          <div className="content-section blog-main-content">
            <h2 className="section-title">Spending on Members is an Expenditure or an Investment?</h2>
            <p>
              Members are the backbone of your organization. Learn why giving a good well being to your 
              team is important and how it can help your organization to grow...! Fill the form.
            </p>
          </div>

          {/* Benefits Grid */}
          <div className="blog-benefits-section">
            <h2 className="section-title">Why Invest in Your Members' Well-being?</h2>
            <div className="blog-benefits-list">
              {benefits.map((benefit, index) => (
                <div 
                  key={index} 
                  className={`blog-benefit-item ${benefit.imagePosition === 'right' ? 'image-right' : 'image-left'}`}
                >
                  <div className="blog-benefit-content">
                    <h3>{benefit.title}</h3>
                    <p>{benefit.description}</p>
                  </div>
                  <div className="blog-benefit-image">
                    <img src={benefit.image} alt={benefit.title} />
                    {benefit.icon && <div className="blog-benefit-icon">{benefit.icon}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default ForBusiness;
